import React from 'react'
import Fotter from './Fotter'

const Career = () => {
  return (
    <div>
      <Fotter/>
    </div>
  )
}

export default Career